// Strings locales de la pantalla /scopes (M3). Sin literales sueltos en JSX (docs/05 §8).
export const scopesI18n = {
  pageDescription: "Permisos con formato recurso:accion, globales o por dominio.",
  newScope: "Nuevo scope",
  refresh: "Actualizar",
  searchLabel: "Buscar scopes",
  searchPlaceholder: "Buscar por clave",
  emptyTitle: "Aún no hay scopes",
  emptyDescription: "Crea el primer scope para definir los permisos de la instancia.",
  emptyAction: "Crear el primer scope",
  // Columnas del DataGrid
  colKey: "Clave",
  colDescription: "Descripción",
  colScope: "Alcance",
  colActions: "Acciones",
  scopeGlobal: "Instancia",
  scopeDomain: "Dominio",
  // Acciones de fila
  editScope: "Editar scope",
  deleteScope: "Eliminar scope",
  rowActions: "Acciones del scope",
  // Drawer de alta/edición
  createTitle: "Nuevo scope",
  editTitle: "Editar scope",
  keyLabel: "Clave",
  keyPlaceholder: "p. ej. telemetry:read",
  keyHint: "Formato recurso:accion (minúsculas, p. ej. devices:write).",
  keyReadonlyHint: "La clave identifica al scope y no se puede cambiar.",
  descriptionLabel: "Descripción",
  descriptionPlaceholder: "Qué autoriza este scope (opcional)",
  // Diálogo de borrado
  deleteTitle: "Eliminar scope",
  deleteConfirm: "Eliminar",
  deleteMessage: (key: string) =>
    `¿Eliminar el scope "${key}"? Se quitará de todos los roles que lo incluyan. Esta acción no se puede deshacer.`,
  // Validación inline
  keyRequired: "Escribe la clave del scope.",
  keyFormat: "Formato esperado: recurso:accion (p. ej. devices:read).",
  // Feedback
  createError: "No se pudo crear el scope.",
  updateError: "No se pudo guardar el scope.",
  deleteError: "No se pudo eliminar el scope.",
} as const
